/**
 * Links that open the user's own WhatsApp or SMS app with a message ready
 * for a member: they only press send. The message comes from the user's
 * phone, not the association's WhatsApp number (that one is used by arqam for
 * invoices, through approved templates).
 */

/** "+212 6 12…" → "212612…" (wa.me takes digits only, with country code). */
const digits = (phone: string) => phone.replace(/\D/g, '');

export const whatsappLink = (phone: string, text: string) =>
  `https://wa.me/${digits(phone)}?text=${encodeURIComponent(text)}`;

/** `sms:` with a body; `?body=` works on Android and current iPhones. */
export const smsLink = (phone: string, text: string) =>
  `sms:+${digits(phone)}?body=${encodeURIComponent(text)}`;
